import Modal from '../../core/modal'
import CreateEditIncident from './CreateEditIncident'

const IncidentModal = ({
    isOpen,
    isEdit,
    onClose,
    incident,
    allMembers,
    allComponents,
    setCheckedIncidentsIds,
    setSelectedTab,
    text
}) => {
    return <Modal
        contentClassName="overflow-auto"
        title={isEdit ? text.edit_incident : text.add_incident}
        closeModal={onClose}
        isOpen={isOpen}>
        <CreateEditIncident
            isEdit={isEdit}
            incident={incident}
            closeModal={onClose}
            setCheckedIncidentsIds={setCheckedIncidentsIds}
            setSelectedTab={setSelectedTab}
            allMembers={allMembers}
            allComponents={allComponents}
        />
    </Modal>
}

export default IncidentModal
